import React from "react"
export function FlexiflyLogoMono(props) {
  return (
    <svg viewBox="0 0 96 24" {...props}>
      <g
        id="prefix__FF-Logo-Monochrome"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="prefix__FF">
          <path
            d="M2.756 1.335a15.372 15.372 0 0112.517-.003l2.513 1.119c.97 7.87-1.956 13.604-8.78 17.204-2.995-1.67-5.243-3.673-6.744-6.008l6.53-3.772.777 5.183.935-.736.566-5.939 3.005-1.968c.969-.7-.17-2.207-1.127-1.517l-2.9 1.9L4.73 5.352l-.924.755L7.771 8.29l-6.093 4.363C.123 9.732-.351 6.332.255 2.45z"
            id="prefix__Combined-Shape"
            fill="currentColor"
          />
          <path
            d="M31.955 4.906H26.48v4.087h5.167v2.513H26.48v6.67H23.4V2.323h8.556v2.583zm5.476 13.27h-3.034V1.03h3.034v17.145zm12.918-6.717c0 .4-.024.869-.095 1.362h-7.3c-.024 2.184 1.066 3.241 3.247 3.241 1.161 0 2.417-.258 3.437-.728l.284 2.325c-1.256.493-2.75.751-4.219.751-3.745 0-5.83-1.855-5.83-5.965 0-3.57 1.99-6.2 5.522-6.2 3.437 0 4.954 2.325 4.954 5.214zm-3.01-.681c.047-1.456-.759-2.325-2.039-2.325-1.256 0-2.133.916-2.3 2.325h4.338zm16.165 7.398h-3.816l-2.276-3.922-2.275 3.922H51.51l4.053-5.895-3.816-5.778h3.627l2.275 3.852 2.3-3.852h3.341l-3.674 5.754 3.888 5.919zm5.31-15.007c0 1.01-.854 1.831-1.897 1.831-1.043 0-1.873-.822-1.873-1.831 0-.987.83-1.809 1.873-1.809 1.043 0 1.896.799 1.896 1.809zm-.38 15.007H65.4V6.503h3.034v11.673zm14.103 0h-3.01V3.403a9.891 9.891 0 00-1.66-.14c-1.682 0-2.536.704-2.536 2.254v.986h2.584v2.325H75.33v9.348h-3.01V8.828H70.26V6.503h2.062V5.376c0-2.7 1.66-4.556 5.807-4.556 1.21 0 2.82.164 4.409.4v16.956zM96 6.503l-4.835 12.753C89.766 22.896 88.534 24 85.832 24a7.81 7.81 0 01-1.66-.188l.19-2.583a5.38 5.38 0 001.612.258c.995 0 1.659-.446 2.275-2.184l.403-1.127-4.337-11.673h3.365l1.588 4.463c.356 1.01.664 2.16.925 3.217h.024c.26-1.057.758-2.607 1.137-3.71l1.399-3.97H96z"
            id="prefix__Flexi\xDFy"
            fill="#231F20"
            fillRule="nonzero"
          />
        </g>
      </g>
    </svg>
  )
}
